import { render, staticRenderFns } from "./VariationForm.vue?vue&type=template&id=94467198&scoped=true"
import script from "./VariationForm.vue?vue&type=script&lang=js"
export * from "./VariationForm.vue?vue&type=script&lang=js"
import style0 from "./VariationForm.vue?vue&type=style&index=0&id=94467198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94467198",
  null
  
)

export default component.exports